/**
 * @extends storeLocator.StaticDataFeed
 * @constructor
 */
function DaiwaDataSource() {
    $.extend(this, new storeLocator.StaticDataFeed);
  
    var that = this;
    $.get('https://daiwa-au-b2c.devotedigital.workers.dev/?type=store-locator', function (data) {
      var csv = '';
      for (i = 0; i < data.valueRanges['0'].values.length; i++) {
          if (data.valueRanges['0'].values[i][0].indexOf('TACKLE WORLD') != -1) {
              var cellData = [];
                for (x = 0; x < data.valueRanges['0'].values[i].length; x++) {
                    cellData[x] = data.valueRanges['0'].values[i][x].replace(',', ';');
                }
                csv += cellData + '\n';
          }
      }
      that.setStores(that.parse_(csv));
    });
  }
  /**
   * @const
   * @type {!storeLocator.FeatureSet}
   * @private
   */
  /**
   * @return {!storeLocator.FeatureSet}
   */
  DaiwaDataSource.prototype.getFeatures = function () {
    return this.FEATURES_;
  };
  
  /**
   * @private
   * @param {string} csv
   * @return {!Array.<!storeLocator.Store>}
   */
  DaiwaDataSource.prototype.parse_ = function (csv) {
  
    var stores = [];
    var rows = csv.split('\n');
    var headings = ['Shop_Name,CUSTOMER NUMBER,Phone_Number,Shop_Number,Shop_Street,Shop_City,Shop_State,Shop_Postcode,Latitude,Longitude,NAV NAME,RANK,Category']
    for (var i = 0; i < rows.length; i++) {
      var singleCell = rows[i].split(',');
      var singleHead = headings[0].split(',');
      var singleObject = {};
      for (var x = 0; x < singleHead.length; x++) {
        if (singleCell[x] != null && singleCell[x] != '') {
          var cleanCell = singleCell[x].replace(";", ",")
          var cleanHeader = singleHead[x].replace(/(\r\n|\n|\r)/gm, "");
          singleObject[cleanHeader] = cleanCell;
        }
      }
  
      var position = new google.maps.LatLng(singleObject.Latitude, singleObject.Longitude);
      var street = this.join_([singleObject.Shop_Number, singleObject.Shop_Street], ' ');
      var shop = this.join_([street, singleObject.Shop_City], ', ');
      var locality = this.join_([singleObject.Shop_State, singleObject.Shop_Postcode], ', ');
      var callus = new storeLocator.Feature('1', '<a class="action directions callUs" href="tel:' + singleObject.Phone_Number + '" onclick="clickCallStore(\'' + singleObject.Shop_Name + '\')">CALL US</a>');
      var directions = new storeLocator.Feature('2', '<a class="action directions" href="https://www.google.com/maps/search/?api=1&query=' + shop.split(' ').join('+') + ',' + locality.split(' ').join('+') + '" onclick="clickDirectionStore(\'' + singleObject.Shop_Name + '\')" target="_blank">DIRECTIONS</a>');
      var features = new storeLocator.FeatureSet(callus, directions);
  
      if (singleObject.Phone_Number == null) {
        var isTelHidden = 'd-none';
      } else {
        var isTelHidden = '';
      }
  
      var store = new storeLocator.Store(i, position, features, {
        title: singleObject.Shop_Name,
        address: this.join_([shop, locality], '<br>'),
        category: 'https://cdn.shopify.com/s/files/1/0060/3770/0678/files/' + singleObject.Category + '-marker.png?16296',
        phone: '<a href="tel:' + singleObject.Phone_Number + '" onclick="clickCallStore(\'' + singleObject.Shop_Name + '\')" class="' + isTelHidden + '">' + singleObject.Phone_Number + '</a>'
      });
      stores.push(store);
    }
  
    return stores;
  
  };
  
  
  /**
   * Joins elements of an array that are non-empty and non-null.
   * @private
   * @param {!Array} arr array of elements to join.
   * @param {string} sep the separator.
   * @return {string}
   */
  DaiwaDataSource.prototype.join_ = function (arr, sep) {
    var parts = [];
    for (var i = 0, ii = arr.length; i < ii; i++) {
      arr[i] && parts.push(arr[i]);
    }
    return parts.join(sep);
  };
  
  /**
   * Very rudimentary CSV parsing - we know how this particular CSV is formatted.
   * IMPORTANT: Don't use this for general CSV parsing!
   * @private
   * @param {string} row
   * @return {Array.<string>}
   */
  DaiwaDataSource.prototype.parseRow_ = function (row) {
    // Strip leading quote.
    if (row.charAt(0) == '"') {
      row = row.substring(1);
    }
    // Strip trailing quote. There seems to be a character between the last quote
    // and the line ending, hence 2 instead of 1.
    if (row.charAt(row.length - 2) == '"') {
      row = row.substring(0, row.length - 2);
    }
  
    row = row.split('","');
  
    return row;
  };
  
  /**
   * Creates an object mapping headings to row elements.
   * @private
   * @param {Array.<string>} headings
   * @param {Array.<string>} row
   * @return {Object}
   */
  DaiwaDataSource.prototype.toObject_ = function (headings, row) {
    var result = {};
    for (var i = 0, ii = row.length; i < ii; i++) {
      result[headings[i]] = row[i];
    }
    return result;
  };